import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";
import { satExpandChevronCn } from "@/lib/expandableSatRail";

/** Celda final de fila expandible en tablas (mismo chevron/carril que hubs y visor). */
export function SatExpandTableRailCell({ open, className }) {
  return (
    <td className={cn("w-10 border-l border-slate-200 p-0 align-middle", className)} aria-hidden>
      <div className="flex min-h-[2.25rem] items-center justify-center">
        <ChevronDown className={satExpandChevronCn(open)} />
      </div>
    </td>
  );
}
